import {pageInfo,update,getDetailById} from '../api';
import {plant,sampleType} from '../../../../../api'
const configToxinSample = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateObj: null,
    plantObj: null,
    initDataObj: null,
    sampleTypeObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    UPDATE(state, data){
      state.updateObj = data;
    },
    SAMPLE_TYPE(state, data){
      state.sampleTypeObj = data;
    },
    INIT_DATA(state,data){
      state.initDataObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async update({commit}, obj){
      let resp = await update(obj);
      commit('UPDATE', resp);
    },
    async sampleType({commit}, obj){
      let resp = await sampleType(obj);
      commit('SAMPLE_TYPE', resp);
    },
    async getDetailById({commit}, obj){
      let resp = await getDetailById(obj);
      commit('INIT_DATA',resp);
    }
  }
}
export default configToxinSample



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/configToxinSample/store/configToxinSample.store.js